export const MAX_TOASTS = 2;
